// Country-specific landing pages for SEO Latam
// Each entry powers a dedicated page at /yoga-oncologico-{slug}

export const COUNTRIES = {
  mexico: {
    slug: "mexico",
    country: "México",
    flag: "🇲🇽",
    capital: "Ciudad de México",
    cities: "CDMX, Guadalajara, Monterrey, Puebla, Mérida y todo México",
    timezone: "Compatible con horarios de México (GMT-6 / GMT-5)",
    pronoun: "tú",
    seoTitle: "Yoga Oncológico Online en México · Acompañamiento Cáncer | Método TAO",
    seoDescription:
      "Acompañamiento cuerpo-mente para pacientes oncológicas en México. Sesiones online en español con horarios mexicanos. Yoga oncológico, fibromialgia y dolor crónico desde CDMX, Guadalajara, Monterrey o cualquier ciudad. Primera sesión gratuita.",
    heroEyebrow: "Sesiones online · México",
    heroTitle: "Acompañamiento <em>cuerpo-mente</em> desde España, contigo en México.",
    heroBody:
      "Trabajo cada semana con mujeres mexicanas que atraviesan un proceso oncológico, fibromialgia o dolor crónico. Sesiones privadas por videollamada, en español, adaptadas al horario de México y a tu momento real.",
    keywords: [
      "yoga oncológico México",
      "acompañamiento cáncer México",
      "yoga restaurativo CDMX online",
      "fibromialgia online México",
    ],
  },
  argentina: {
    slug: "argentina",
    country: "Argentina",
    flag: "🇦🇷",
    capital: "Buenos Aires",
    cities: "Buenos Aires, Córdoba, Rosario, Mendoza, La Plata y todo el país",
    timezone: "Compatible con horarios de Argentina (GMT-3)",
    pronoun: "vos",
    seoTitle: "Yoga Oncológico Online en Argentina · Acompañamiento Cáncer | Método TAO",
    seoDescription:
      "Acompañamiento cuerpo-mente online para mujeres en Argentina con cáncer, fibromialgia o dolor crónico. Sesiones privadas en español adaptadas a tu zona horaria desde Buenos Aires, Córdoba, Rosario o cualquier provincia. Primera sesión gratuita de 15 minutos.",
    heroEyebrow: "Sesiones online · Argentina",
    heroTitle: "Acompañamiento sensible para <em>vos</em>, desde España.",
    heroBody:
      "Acompaño cada semana a mujeres argentinas en proceso oncológico, fibromialgia o dolor crónico. Sesiones online por videollamada, en español, adaptadas al horario argentino. Sin desplazamientos, con la misma profundidad que una sesión presencial.",
    keywords: [
      "yoga oncológico Argentina",
      "acompañamiento cáncer Argentina",
      "yoga restaurativo Buenos Aires online",
      "fibromialgia online Argentina",
    ],
  },
  colombia: {
    slug: "colombia",
    country: "Colombia",
    flag: "🇨🇴",
    capital: "Bogotá",
    cities: "Bogotá, Medellín, Cali, Barranquilla, Cartagena y todo el país",
    timezone: "Compatible con horarios de Colombia (GMT-5)",
    pronoun: "tú",
    seoTitle: "Yoga Oncológico Online en Colombia · Acompañamiento Cáncer | Método TAO",
    seoDescription:
      "Acompañamiento cuerpo-mente para mujeres colombianas con diagnóstico oncológico, fibromialgia o dolor crónico. Sesiones online en español adaptadas al horario de Colombia desde Bogotá, Medellín, Cali o cualquier ciudad. Primera sesión gratuita.",
    heroEyebrow: "Sesiones online · Colombia",
    heroTitle: "Acompañamiento <em>cuerpo-mente</em> desde España, contigo en Colombia.",
    heroBody:
      "Trabajo con mujeres colombianas que atraviesan procesos oncológicos, fibromialgia o dolor crónico. Sesiones online por videollamada, en español, ajustadas al horario colombiano y a tu energía real de cada semana.",
    keywords: [
      "yoga oncológico Colombia",
      "acompañamiento cáncer Colombia",
      "yoga restaurativo Bogotá online",
      "fibromialgia online Colombia",
    ],
  },
  chile: {
    slug: "chile",
    country: "Chile",
    flag: "🇨🇱",
    capital: "Santiago",
    cities: "Santiago, Valparaíso, Concepción, La Serena, Antofagasta y todo Chile",
    timezone: "Compatible con horarios de Chile (GMT-3 / GMT-4 según temporada)",
    pronoun: "tú",
    seoTitle: "Yoga Oncológico Online en Chile · Acompañamiento Cáncer | Método TAO",
    seoDescription:
      "Acompañamiento cuerpo-mente online para mujeres en Chile con cáncer, fibromialgia o dolor crónico. Sesiones privadas en español adaptadas a la zona horaria chilena desde Santiago, Valparaíso o cualquier región. Primera sesión gratuita.",
    heroEyebrow: "Sesiones online · Chile",
    heroTitle: "Acompañamiento <em>sensible</em>, desde España, contigo en Chile.",
    heroBody:
      "Acompaño a mujeres chilenas que atraviesan procesos oncológicos, fibromialgia o dolor crónico. Sesiones online por videollamada, en español, adaptadas al horario chileno y a tu momento real.",
    keywords: [
      "yoga oncológico Chile",
      "acompañamiento cáncer Chile",
      "yoga restaurativo Santiago online",
      "fibromialgia online Chile",
    ],
  },
};

export const COUNTRY_LIST = Object.values(COUNTRIES);
